import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import config from '../helpers/config';
import { getDesignUrl } from '../helpers/updateEstimateURL';

const FallbackLoader = ({ selectedEstimate }) => {
  if (selectedEstimate) {
    return <Redirect to={getDesignUrl(selectedEstimate)} />;
  }

  return <Redirect to={`${config.estimatebuilderBasePath}/new`} />;
};
FallbackLoader.propTypes = {
  selectedEstimate: PropTypes.shape({}),
};
FallbackLoader.defaultProps = {
  selectedEstimate: null,
};
export default FallbackLoader;

